module.exports = __webpack_public_path__ + "static/img/01.466d5e9d.jpg";